export const titleAlert = {
    'confirm_submit_1': "Xác nhận hoàn thành?",
    'confirm_submit_2': "Hoàn thành ôn tập?",
    'confirm_submit_3': "Xác nhận hoàn thành?",
};
